module.exports = __webpack_public_path__ + "static/photo8-219dad281116e5398d0f6c845fe928ff.jpg";